import { render } from "../../templates/partner-cart-technology-park-recommended.html?vue&type=template&id=3325268c"
import script from "./technology-park-recommended.vue?vue&type=script&lang=js"
export * from "./technology-park-recommended.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__